import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { StoreService } from '../store.service';
import { ApiBaseService } from './api-base.service';
import ApiOptionsConfig from './api-options.config';
import { JurisdictionsService } from './general-settings/jurisdictions.service';
import { ItemTypesService } from './general-settings/item-types.service';
import { CountriesService } from './general-settings/countries.service';
import { ItemProductsService } from './general-settings/item-products.service';
import { LawsService } from './general-settings/laws.service';
import { RequestsService } from './requests.service';
import { CustomerService } from './customer.service';
import { ProjectsService } from './projects.service';
import { UserService } from './user.service';
import { COMPANY_DOCUMENT_REVISION_STATUS_LABELS, CompanyDocumentRevisionStatus } from 'src/app/models/entities/company-document';
import { PlanningUser, planningUserFullName } from 'src/app/models/entities/planning';
import { RiskTimeFrame } from 'src/app/models/entities/risk';
import { QualityManagementService } from '../quality-management.service';
import {
  SCAN_STATUS_LABELS,
  VLT_STATUS_LABELS,
  WEBSITE_ANALYSIS_STATUS_LABELS,
  WEBSITE_SCAN_STATUS_LABELS
} from 'src/app/models/entities/regulator';

const BASE_URL = '/options';

@Injectable({
  providedIn: 'root'
})
export class OptionService extends ApiBaseService {
  [key: string]: any;
  params = new HttpParams().set('size', '999');

  private rankings = [
    { key: 1, value: '1' },
    { key: 2, value: '2' },
    { key: 3, value: '3' },
    { key: 4, value: '4' },
    { key: 5, value: '5' },
    { key: 6, value: '6' },
    { key: 7, value: '7' },
    { key: 8, value: '8' },
    { key: 9, value: '9' },
    { key: 10, value: '10' },
    { key: 11, value: '11' },
    { key: 12, value: '12' },
    { key: 13, value: '13' },
    { key: 14, value: '14' },
    { key: 15, value: '15' },
  ]

  private isClients = [
    { key: true, value: 'Yes' },
    { key: false, value: 'No' }
  ];

  private booleanOptions = [
    { key: true, value: 'Yes' },
    { key: false, value: 'No' }
  ];

  private archiveds = [
    { key: true, value: 'Yes' },
    { key: false, value: 'No' }
  ];

  constructor(
    private jurisdictionsService: JurisdictionsService,
    private itemProductsService: ItemProductsService,
    private itemsTypesService: ItemTypesService,
    private countriesService: CountriesService,
    private lawsService: LawsService,
    private requetsService: RequestsService,
    private customersService: CustomerService,
    private projectService: ProjectsService,
    private userService: UserService,
    private qualityManagementService: QualityManagementService
  ) {
    super();
  }

 
  makeGet(urlSuffix: string, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}${urlSuffix}`), options?.params);
  }

  /***************
    USER OPTIONS
  / ************* */
  userStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/user/status', options);
  }
  userProfile(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/user/profile', options);
  }
  /***************
    JURISDICTION OPTIONS
  / ************* */
  jurisdactionTypes(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/jurisdiction/type', options);
  }

  clientsRoles(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/customer/role', options);
  }

  /***************
    INTRODUCER OPTIONS
  **************/

  introducers(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl('/introducers'), options?.params)
  }


  /***************
    REQUEST
  ****************/

  requestStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/request/status', options);
  }

  /***************
    PROPOSALS 
  ****************/

  proposalModels(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/proposal/template-format', options);
  }

  proposalPaymentCompany(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/proposal/payment-company', options);
  }

  /***************
    PROJECTS
  ****************/

  projectStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/project/status', options);
  }

  /***************
   PLATFORM OPTIONS
  ****************/

  platforms(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.GET(this.getUrl('/platforms'), options?.params);
  }


  /***************
   EMPLOYEE / CONSULTANT OPTIONS
  *****************/

  employeeStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/employee/status', options);
  }

  employeeContractType(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/employee/contract-type', options);
  }


  /****************
   FILTERS PROJECT ISSUE OPTIONS
  *****************/

  projectIssueFilterPriority(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`/projects/${projectId}/project-issues${BASE_URL}/priorities`), options?.params);;
  }

  projectIssueFilterJurisdictions(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`/projects/${projectId}/project-issues${BASE_URL}/jurisdictions`), options?.params);
  }

  projectIssueFilterWorkingListNames(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`/projects/${projectId}/project-issues${BASE_URL}/project-workinglists`), options?.params);
  }

  projectIssueFilterTestName(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`/projects/${projectId}/project-issues${BASE_URL}/testlists`), options?.params);
  }

  projectIssueFilterStatus(projectId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`/projects/${projectId}/project-issues${BASE_URL}/statuses`), options?.params);
  }

  /****************
   PROJECT ISSUE OPTIONS
  *****************/

  projectIssuePriorities(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/project/project-issue/priority', options);
  }

  projectIssueStatuses(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/project/project-issue/status', options);
  }

  /****************
   COMPLAINT OPTIONS
  *****************/

  complaintStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/complaint/status', options);
  }

  complaintPriorities(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/complaint/priority', options);
  }

  complaintReminderStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/complaint/reminder-status', options);
  }

  complaintMonitor(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/complaint/monitor', options);
  }

  /****************
   ANTIVIRUS LOG OPTIONS
  *****************/

  antivirusLogStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/antivirus-log/status', options);
  }

  /****************
   FILE MANAGER AUDIT OPTIONS
  *****************/

  fileManagerAuditAction(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/file-manager-audit/actions', options).pipe(
      map((response: any) => ({
        ...response,
        data: {
          ...response?.data,
          options: (response?.data?.options ?? []).filter((option: any) => option.key !== 'LIST')
        }
      }))
    );
  }

  private fileManagerAuditStatuses = [
    { key: 'SUCCESS', value: 'Success' },
    { key: 'FAILURE', value: 'Failure' },
    { key: 'IN_PROGRESS', value: 'In progress' }
  ];

  fileManagerAuditStatus(options?: ApiOptionsConfig): Observable<{ data: { options: { key: string, value: string }[] } }> {
    const result = { data: { options: this.fileManagerAuditStatuses } };
    return new Observable<{ data: { options: { key: string, value: string }[] } }>(observer => {
      observer.next(result);
      observer.complete();
    });
  }

  staffUsers(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.userService.list({ params: this.params }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.users) {
          const users = response.data.users.map((user: any) => ({
            key: user.userId,
            value: `${user.firstName} ${user.lastName}`
          }));
          return { data: { options: users } };
        }
        return { data: { options: [] } };
      })
    );
  }


  /***************
     VARIABLE OPTIONS
   / ************* */


  jurisdictions(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {

    return this.jurisdictionsService.list({ params: this.params }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.jurisdictions) {
          const jurisdictions = response.data.jurisdictions.map((jurisdiction: any) => ({
            key: jurisdiction.jurisdictionId,
            value: jurisdiction.name
          }));
          return { data: { options: jurisdictions } };
        }
        return { data: { options: [] } };
      })
    );
  }

  laws(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {

    return this.lawsService.list({ params: this.params }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.laws) {
          const laws = response.data.laws.map((law: any) => ({
            key: law.lawId,
            value: law.name
          }));
          return { data: { options: laws } };
        }
        return { data: { options: [] } };
      })
    );
  }

  itemProducts(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {

    return this.itemProductsService.list({ params: this.params }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.itemProducts) {
          const itemProducts = response.data.itemProducts.map((itemProduct: any) => ({
            key: itemProduct.itemProductId,
            value: itemProduct.name
          }));
          return { data: { options: itemProducts } };
        }
        return { data: { options: [] } };
      })
    );
  }

  itemTypes(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {

    return this.itemsTypesService.list({ params: this.params }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.itemTypes) {
          const itemTypes = response.data.itemTypes.map((itemType: any) => ({
            key: itemType.itemTypeId,
            value: itemType.name
          }));
          return { data: { options: itemTypes } };
        }
        return { data: { options: [] } };
      })
    );
  }

  countries(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.countriesService.list({ params: this.params }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.countries) {
          const countries = response.data.countries.map((country: any) => ({
            key: country.countryId,
            value: country.name
          }));
          return { data: { options: countries } };
        }
        return { data: { options: [] } };
      })
    );
  }

  ranking(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: any }[] } }> {
    const rkg = { data: { options: this.rankings } };
    return new Observable<{ data: { options: { key: any, value: any }[] } }>(observer => {
      observer.next(rkg);
      observer.complete();
    });
  }

  archived(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: any }[] } }> {
    const archived = { data: { options: this.archiveds } };
    return new Observable<{ data: { options: { key: any, value: any }[] } }>(observer => {
      observer.next(archived);
      observer.complete();
    });
  }

  categoryProposal(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.requetsService.listSettingsRequestCategories({ params: this.params }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.requestCategories) {
          const categories = response.data.requestCategories?.map((category: any) => ({
            key: category.requestCategoryId,
            value: category.name
          }));
          return { data: { options: categories } };
        }
        return { data: { options: [] } };
      })
    );
  }

  source(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return of({ data: { options: [{ key: 'MAIL', value: 'MAIL' }, { key: 'PHONE_CALL', value: 'PHONE_CALL' }, { key: 'SYSTEM', value: 'SYSTEM' }] } });
  }

  clientTypes(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.customersService.listSettingsClientsTypes({ params: this.params }).pipe(
      map((response: any) => {
        if (response && response.data && response.data.customerTypes) {
          const customerTypes = response?.data?.customerTypes?.map((clientType: any) => ({ key: clientType.customerTypeId, value: clientType.name }));
          return { data: { options: customerTypes } };
        }
        return { data: { options: [] } };
      })
    );
  }

  projectGlobalJurisdictions(projectId: any, options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.projectService.optionsJurisdictions(projectId, { params: this.params }).pipe(
      map((response: any) => {
        console.log(response);

        if (response && response.data && response.data.options) {
          const jurisdictions = response.data.options.map((jurisdiction: any) => ({
            key: jurisdiction.key,
            value: jurisdiction.value
          }));
          return { data: { options: jurisdictions } };
        }
        return { data: { options: [] } };
      })
    );
  }


  isClient(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: any }[] } }> {
    const iC = { data: { options: this.isClients } };
    return new Observable<{ data: { options: { key: any, value: any }[] } }>(observer => {
      observer.next(iC);
      observer.complete();
    });
  }

  boolean(option?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    const boolOpt = { data: { options: this.booleanOptions } };
    return new Observable<{ data: { options: { key: any, value: string }[] } }>(observer => {
      observer.next(boolOpt);
      observer.complete();
    });
  }

  /***************
    ACTIVITY PLANNING OPTIONS
  / ************* */
  planningStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/activity-planning/status', options);
  }

 
  planningAssignees(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.qualityManagementService.listPlanningAssignableUsers({ params: options?.params ?? this.params }).pipe(
      map((response: any) => {
        const users: PlanningUser[] = this.qualityManagementService.readResponseKey(response, 'users', 'assignableUsers') ?? [];

        const assignees = users
          .filter(user => user?.userId != null)
          .map(user => ({ key: user.userId, value: planningUserFullName(user) }));

        return { data: { options: assignees } };
      })
    );
  }

  /***************
    COMPANY DOCUMENT OPTIONS
  / ************* */
  companyDocumentDepartments(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/company-document/departments', options);
  }

  companyDocumentGroups(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/company-document/groups', options);
  }

  companyDocumentRevisionStatus(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    const statusOptions = (Object.keys(COMPANY_DOCUMENT_REVISION_STATUS_LABELS) as CompanyDocumentRevisionStatus[])
      .map(status => ({ key: status, value: COMPANY_DOCUMENT_REVISION_STATUS_LABELS[status] }));

    return of({ data: { options: statusOptions } });
  }

  /***************
    RISK OPTIONS
  / ************* */
  riskTypes(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/risk/types', options);
  }

  riskStatuses(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/risk/statuses', options);
  }

  riskPriorities(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/risk/priorities', options);
  }

  riskTimeFrames(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.qualityManagementService.listRiskTimeFrames({ params: options?.params ?? this.params }).pipe(
      map((response: any) => {
        const timeFrames: RiskTimeFrame[] =
          this.qualityManagementService.readResponseKey(response, 'riskTimeFrames') ?? [];

        const timeFrameOptions = timeFrames
          .filter(timeFrame => timeFrame?.riskTimeFrameId != null)
          .map(timeFrame => ({ key: timeFrame.riskTimeFrameId, value: timeFrame.name }));

        return { data: { options: timeFrameOptions } };
      })
    );
  }

  riskResponsibles(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.planningAssignees(options);
  }

  /***************
    MEETING MINUTE OPTIONS
  / ************* */
  meetingMinuteDepartments(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/meeting-minute/departments', options);
  }

  meetingMinuteParticipantStatuses(options?: ApiOptionsConfig): Observable<any> {
    return this.makeGet('/meeting-minute/participant-statuses', options);
  }

  meetingMinuteUsers(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.planningAssignees(options);
  }

  projectFinanceUsers(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return this.planningAssignees(options);
  }

  /***************
    REGULATOR OPTIONS
  / ************* */
  websiteScanStatuses(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return of({ data: { options: this.labelsToOptions(WEBSITE_SCAN_STATUS_LABELS) } });
  }

  websiteAnalysisStatuses(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return of({ data: { options: this.labelsToOptions(WEBSITE_ANALYSIS_STATUS_LABELS) } });
  }

  vltStatuses(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return of({ data: { options: this.labelsToOptions(VLT_STATUS_LABELS) } });
  }

  scanStatuses(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return of({ data: { options: this.labelsToOptions(SCAN_STATUS_LABELS) } });
  }

  scanComplianceOptions(options?: ApiOptionsConfig): Observable<{ data: { options: { key: any, value: string }[] } }> {
    return of({ data: { options: [{ key: 'true', value: 'Compliant' }, { key: 'false', value: 'Non Compliant' }] } });
  }

  private labelsToOptions(labels: Record<string, string>): { key: string, value: string }[] {
    return Object.entries(labels).map(([key, value]) => ({ key, value }));
  }

}
